import Styled from 'styled-components'

export default Styled.div`
    h1 {
    }
`
